export enum InsightStateEnum {
  Loading = "Loading",
  Error = "Error",
  Success = "Success",
  NoData = "NoData",
}
